import * as Yup from "yup";
import {yupRequiredString} from "../yup/Validators";

export const createDocumentSchema =
  Yup.object().shape({
    attachmentFile: yupRequiredString
})
